export default __webpack_public_path__ + "static/media/bacon.365f2648.png";